import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import "antd/dist/antd.css";
import React from 'react';
import { HelmetProvider } from 'react-helmet-async';

import Router from "./router";
import i18n from "./translation"
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { LocationProvider } from './contexts/geoLocationContext';
import UserProvider from './contexts/userContext';
import store from './redux/store';
import { Provider } from "react-redux";
import UmamiTracker from './components/UmamiTracker';

// Get Umami configuration from environment variables with fallbacks
const UMAMI_WEBSITE_ID = process.env.REACT_APP_UMAMI_WEBSITE_ID || "12f37d3f-1f73-4e4d-95c5-c1cfc5efcfcd";
const UMAMI_SCRIPT_URL = process.env.REACT_APP_UMAMI_SCRIPT_URL || "https://umami.nijulishe.co.ke/nijulishe-analytics.js";
const ENABLE_GEOLOCATION = process.env.REACT_APP_ENABLE_GEOLOCATION === 'true';

// Define a component that wraps the UmamiTracker to handle errors
const SafeUmamiTracker: React.FC<{
  websiteId: string;
  scriptUrl?: string;
  enableGeolocation?: boolean;
}> = (props) => {
  try {
    return <UmamiTracker {...props} includeQueryParams={true} />;
  } catch (error) {
    console.error('Failed to initialize :', error);
    return null;
  }
};

const App = () => (
    <I18nextProvider i18n={i18n}>
      {/* Add Umami analytics tracking with error handling */}
      <SafeUmamiTracker 
        websiteId={UMAMI_WEBSITE_ID}
        scriptUrl={UMAMI_SCRIPT_URL}
        enableGeolocation={ENABLE_GEOLOCATION}
      />
      <Router />
    </I18nextProvider>
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

// Create root with React 18's createRoot API
const root = ReactDOM.createRoot(rootElement);

// For react-snap, we'll add the proper configuration in package.json
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <UserProvider>
            <LocationProvider>
              <App />
            </LocationProvider>
          </UserProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
